export default __webpack_public_path__ + "60a128f208ad35eeb246dcb14461b02f.png";